import script from "./UpdatePhc.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePhc.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePhc.vue?vue&type=style&index=0&id=db166b5e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db166b5e"]])

export default __exports__